import React from 'react';
import { Link, useParams } from 'react-router-dom'; // Import the necessary dependencies
import "../components css/story.css"

import story from '../stories'
import { useTranslation } from 'react-i18next';

import resh from '../images/1.png'
const Story = () => {
    let {t} = useTranslation();
    const { id } = useParams(); // Access URL parameters using useParams hook
    return (
        <>
            <div style={{ position: "relative" }}>
                <div className="container">
                    <div className="row bookRow">
                        <div className="col-sm-10 col-md-8 col-xsm-11 col-lg-8">
                            <div className="book" >
                                <h2 className="title">{t(story[id].title)}</h2>
                                <h3>({t(story[id].name)})</h3>
                                {story[id].story.map((p, index) => (
                                    <p key={index} className="body">{t(p)}</p>
                                ))}
                                <img src={resh} alt="resha" />
                            </div>
                        </div>
                        <Link to='/stories' className='storiesBut' style={{padding:'15px' , marginBottom:'20px'}}>{t("رجوع")}</Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Story;
